export default __webpack_public_path__ + "static/media/lungs_img_0008_Air_Quality.933142fb.png";